import React, { createElement } from 'react';
(function setInitialHead() {
  const title = 'Improbability Foundation website';
  if (document.title !== title) document.title = title;
  const ensure = (name: string, content: string) => {
    let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', name);
      document.head.appendChild(el);
    }
    if (el.content !== content) el.content = content;
  };
  ensure('description', 'Improbability Foundation');
})();
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
render(<AppRouter data-id="element-99" data-mp="2k179k8gpaxy0" />, document.getElementById('root'));